import Roles from "@/utils/roles"

export default [
    {
        path: "/segmentos-veiculo",
        name: "segmentos-veiculo",
        component: () => import("@/views/area-mention/source-segments/index.vue"),
        meta: {
          title: 'Segmentos de veículo',
          authRequired: true,
          roles: [Roles.SourceSegments]
        },
    },
];
